import { StimulusCheck } from '../stories/kiplinger_tools/stimulus-check/StimulusCheck';

export default function StimulusCheckCalc() {
  return (
    <main>
      <StimulusCheck />
    </main>
  );
}
